import DashboardCard from '@/components/dashboard/dashboard-card'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'

export const Route = createFileRoute('/dashboard/admin/errors/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()

  const { data: employeesWithoutClientCount } = useQuery({
    ...api.employee.getEmployeesWithoutClientCount.queryOptions(),
  })

  return (
    <DashboardShell>
      {/* Header Section */}
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight bg-gradient-to-r from-gray-900 via-indigo-900 to-purple-900 dark:from-white dark:via-indigo-200 dark:to-purple-200 bg-clip-text text-transparent">
          Errors
        </h2>
        <p className="text-lg text-muted-foreground">
          Review and resolve system errors and data inconsistencies
        </p>
      </div>
      <Separator />

      {/* Error Cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <DashboardCard
          description="No Client Assigned"
          title="Employees"
          topRight={
            <Badge variant="outline" className="flex gap-1 rounded-lg text-xs">
              <AlertTriangle className="size-3" />
              {employeesWithoutClientCount ?? 0}
            </Badge>
          }
          footer={
            <div className="flex flex-col w-full gap-y-2 justify-between">
              <div className="text-muted-foreground">
                <span className="font-medium">{employeesWithoutClientCount ?? 0}</span> employees
                without an associated client
              </div>
              <Button className="w-full cursor-pointer" asChild>
                <Link to="/dashboard/admin/employees">Assign Clients</Link>
              </Button>
            </div>
          }
        />
      </div>
    </DashboardShell>
  )
}
